module.exports = __webpack_public_path__ + "img/GAME_model.13bf90ac.webp";